const getters = {
    remoteLogin: state => state.user.remoteLogin,
    userInfo: state => state.user.userInfo,
    token: state => state.user.token,
    courseList: state => state.user.courseList,
    menuScenarioList: state => state.user.menuScenarioList,
    userAuthority: state => state.user.userAuthority,
    rem: state => state.user.rem
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js